import React, { useMemo } from "react";
import stylesCommon from "@/styles/detail/DetailBookingSidebar/DetailBookingConfigurator.module.scss";
import moment from "moment";
import { useStore } from "@/store/index";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import styles from "@/styles/detail/DetailBookingSidebar/PackageConfigurationSectionDetail.module.scss";
import DiscountSectionDetail from "./DiscountSectionDetail";

const PackageConfigurationSectionDetail = ({
    isPremium,
    days,
    startDate,
}: // price,
{
    isPremium: boolean;
    days: number;
    startDate: Date | null;
    // price: number;
}) => {
    // const dispatchCheckout = useStore(state => state.dispatchCheckout);
    const formatPattern = "MMMM D, YYYY";

    const isPets = useStore(state => state.checkoutState.orderData.pets);

    const firstDate = useMemo(
        () => moment(startDate).format(formatPattern).split(","),
        [startDate]
    );
    const getEndDate = () => {
        return moment(startDate)
            .add(days - 1, "days")
            .format(formatPattern)
            .split(",");
    };

    const rooms = useStore(state => state.checkoutState.orderData.rooms) || [];

    const calculateAdults = () => {
        if (!rooms || !Array.isArray(rooms) || rooms.length === 0) {
            return 0;
        }
        return rooms.reduce((previousValue, currentValue) => {
            return previousValue + currentValue.adults;
        }, 0);
    };

    const calculateToddlers = () => {
        if (!rooms || !Array.isArray(rooms) || rooms.length === 0) {
            return 0;
        }
        return rooms.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.newborns ?? 0);
        }, 0);
    };

    const calculateChildrens = () => {
        if (!rooms || !Array.isArray(rooms) || rooms.length === 0) {
            return 0;
        }
        return rooms.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.children?.length ?? 0);
        }, 0);
    };

    const languageSelected = useStore(
        state => state.checkoutState.languageSelected
    );
    const clickLanguage = useStore(state => state.checkoutState.clickLanguage);

    const valueCoupon = useStore(
        state => state.checkoutState.orderData.coupon?.value
    );
    const clickConfirmDate = useStore(
        state => state.checkoutState.clickConfirmDate
    );

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className={stylesCommon.configuratorTitle}>
                    Your package configuration
                </h3>
            </div>
            <ul>
                <li>
                    <p
                        className={`${stylesCommon.configuratorDescription} mt-0 mb-0`}
                    >
                        {isPremium ? "Premium" : "Quality"} package
                    </p>
                </li>
                <li>
                    <p
                        className={`${stylesCommon.configuratorDescription} mt-0 mb-0`}
                    >
                        {days} {days > 1 ? "Days" : "Day"}, {days - 1}{" "}
                        {days - 1 > 1 ? "nights" : "night"}
                    </p>
                </li>
                {firstDate.length > 0 &&
                    firstDate[0] !== "Invalid date" &&
                    clickConfirmDate && (
                        <li>
                            <p
                                className={`${stylesCommon.configuratorDescription} mt-0 mb-0`}
                            >
                                Arrival date on {`${firstDate.at(0)}`}, Return
                                on {`${getEndDate().at(0)}`}
                            </p>
                        </li>
                    )}
                <li>
                    <p
                        className={`${stylesCommon.configuratorDescription} mt-0 mb-0`}
                    >
                        {rooms.length} {rooms.length > 1 ? "Rooms" : "Room"},
                        {calculateAdults() > 0 && ` ${calculateAdults()}`}
                        {calculateAdults() > 0
                            ? calculateAdults() === 1
                                ? " Adult"
                                : " Adults"
                            : ""}
                        {calculateChildrens() > 0 &&
                            `, ${calculateChildrens()}`}
                        {calculateChildrens() > 0
                            ? calculateChildrens() === 1
                                ? " Child"
                                : " Children"
                            : ""}
                        {calculateToddlers() > 0 && `, ${calculateToddlers()}`}
                        {calculateToddlers() >= 1 ? " Toddlers" : ""}
                        {isPets ? ", travelling with pets" : ""}
                    </p>
                </li>
                {languageSelected && clickLanguage && (
                    <li>
                        <p
                            className={`${stylesCommon.configuratorDescription} mt-0 mb-0 text-capitalize`}
                        >
                            {languageSelected} Language
                        </p>
                    </li>
                )}
            </ul>
            <DiscountSectionDetail />
            {/* <MDBRow className={styles.packagePriceRow}>
                <MDBCol size={4}>
                    <p className={styles.packagePriceTitle}>Package price</p>
                </MDBCol>
                <MDBCol size={8}>
                    <p className={styles.packagePricePrice}>
                        {price.toFixed(2)} €
                    </p>
                </MDBCol>
            </MDBRow> */}
            {(valueCoupon ?? 0) > 0 && (
                <MDBRow className={styles.packagePriceRow}>
                    <MDBCol size={4}>
                        <p className={styles.packagePriceTitle}>
                            Coupon discount
                        </p>
                    </MDBCol>
                    <MDBCol size={8}>
                        <p className={styles.packagePricePrice}>
                            - {valueCoupon} €
                        </p>
                    </MDBCol>
                </MDBRow>
            )}

            {/* <MDBRow className={styles.totalRow}>
                <MDBCol size={4}>
                    <p className={styles.total}>
                        Total <span className={styles.eur}>(EUR)</span>
                    </p>
                </MDBCol>
                <MDBCol size={8}>
                    <p className={styles.TotalPrice}>
                        {Number(totalAmount).toFixed(2)}€
                    </p>
                </MDBCol>
            </MDBRow> */}
        </>
    );
};

export default PackageConfigurationSectionDetail;
